module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/fk-fe8e733a5a44d9626de2b2d6ab9084c5.svg";